var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"6fa459ee2fb57ecf1a22e6089785f8ab03be04ee"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from "@sentry/nextjs";
import { resolveEnv } from "./environment";

Sentry.init({
	dsn: process.env.NEXT_PUBLIC_SENTRY_DSN || "",
	// 現在のオリジンから環境を判定する
	environment: resolveEnv(),
	tracesSampleRate: 0
});
